import { render } from "./add-court.vue?vue&type=template&id=1ea97220"
import script from "./add-court.vue?vue&type=script&lang=js"
export * from "./add-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__